import { render, staticRenderFns } from "./IconGamepad2.vue?vue&type=template&id=ca38c0d6"
import script from "./IconGamepad2.vue?vue&type=script&lang=js"
export * from "./IconGamepad2.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports